export const hotSearchPlayData = [
    {
        "id": 1,
        "image": require("../images/hotsearchPlay/play_01.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_01_330w.webp"),
        "name": "關子嶺",
        "link": "https://www.pixnet.net/ppage/關子嶺"
    },
    {
        "id": 2,
        "image": require("../images/hotsearchPlay/play_02.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_02_330w.webp"),
        "name": "德元埤荷蘭村",
        "link": "https://www.pixnet.net/ppage/德元埤荷蘭村"
    },
    {
        "id": 3,
        "image": require("../images/hotsearchPlay/play_03.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_03_330w.webp"),
        "name": "赤崁樓",
        "link": "https://www.pixnet.net/ppage/赤崁樓"
    },
    {
        "id": 4,
        "image": require("../images/hotsearchPlay/play_04.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_04_330w.webp"),
        "name": "十鼓仁糖",
        "link": "https://www.pixnet.net/ppage/十鼓仁糖"
    },
    {
        "id": 5,
        "image": require("../images/hotsearchPlay/play_05.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_05_330w.webp"),
        "name": "神農街",
        "link": "https://www.pixnet.net/ppage/神農街"
    },
    {
        "id": 6,
        "image": require("../images/hotsearchPlay/play_06.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_06_330w.webp"),
        "name": "花園夜市",
        "link": "https://www.pixnet.net/ppage/花園夜市"
    },
    {
        "id": 7,
        "image": require("../images/hotsearchPlay/play_07.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_07_330w.webp"),
        "name": "漁光島",
        "link": "https://www.pixnet.net/ppage/漁光島"
    },
    {
        "id": 8,
        "image": require("../images/hotsearchPlay/play_08.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_08_330w.webp"),
        "name": "安平老街",
        "link": "https://www.pixnet.net/ppage/安平老街"
    },
    {
        "id": 9,
        "image": require("../images/hotsearchPlay/play_09.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_09_330w.webp"),
        "name": "頑皮世界",
        "link": "https://www.pixnet.net/ppage/頑皮世界"
    },
    {
        "id": 10,
        "image": require("../images/hotsearchPlay/play_10.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_10_330w.webp"),
        "name": "水火同源",
        "link": "https://www.pixnet.net/ppage/水火同源"
    },
    {
        "id": 11,
        "image": require("../images/hotsearchPlay/play_11.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_11_330w.webp"),
        "name": "奇美博物館",
        "link": "https://www.pixnet.net/ppage/奇美博物館"
    },
    {
        "id": 12,
        "image": require("../images/hotsearchPlay/play_12.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_12_330w.webp"),
        "name": "曾文水庫",
        "link": "https://www.pixnet.net/ppage/曾文水庫"
    },
    {
        "id": 13,
        "image": require("../images/hotsearchPlay/play_13.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_13_330w.webp"),
        "name": "四草綠色隧道",
        "link": "https://www.pixnet.net/ppage/四草綠色隧道"
    },
    {
        "id": 14,
        "image": require("../images/hotsearchPlay/play_14.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_14_330w.webp"),
        "name": "樹谷農場",
        "link": "https://www.pixnet.net/ppage/樹谷農場"
    },
    {
        "id": 15,
        "image": require("../images/hotsearchPlay/play_15.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_15_330w.webp"),
        "name": "水仙宮",
        "link": "https://www.pixnet.net/ppage/水仙宮"
    },
    {
        "id": 16,
        "image": require("../images/hotsearchPlay/play_16.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_16_330w.webp"),
        "name": "左鎮化石園區",
        "link": "https://www.pixnet.net/ppage/左鎮化石園區"
    },
    {
        "id": 17,
        "image": require("../images/hotsearchPlay/play_17.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_17_330w.webp"),
        "name": "台南公園",
        "link": "https://www.pixnet.net/ppage/台南公園"
    },
    {
        "id": 18,
        "image": require("../images/hotsearchPlay/play_18.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_18_330w.webp"),
        "name": "藍晒圖",
        "link": "https://www.pixnet.net/ppage/藍晒圖"
    },
    {
        "id": 19,
        "image": require("../images/hotsearchPlay/play_19.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_19_330w.webp"),
        "name": "林百貨",
        "link": "https://www.pixnet.net/ppage/林百貨"
    },
    {
        "id": 20,
        "image": require("../images/hotsearchPlay/play_20.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_20_330w.webp"),
        "name": "山上花園水道博物館",
        "link": "https://www.pixnet.net/ppage/山上花園水道博物館"
    },
    {
        "id": 21,
        "image": require("../images/hotsearchPlay/play_21.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_21_330w.webp"),
        "name": "隆田chacha文化資產教育園區",
        "link": "https://www.pixnet.net/ppage/隆田chacha文化資產教育園區"
    },
    {
        "id": 22,
        "image": require("../images/hotsearchPlay/play_22.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_22_330w.webp"),
        "name": "白色教堂",
        "link": "https://www.pixnet.net/ppage/白色教堂"
    },
    {
        "id": 23,
        "image": require("../images/hotsearchPlay/play_23.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_23_330w.webp"),
        "name": "蝸牛巷",
        "link": "https://www.pixnet.net/ppage/蝸牛巷"
    },
    {
        "id": 24,
        "image": require("../images/hotsearchPlay/play_24.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_24_330w.webp"),
        "name": "新化老街",
        "link": "https://www.pixnet.net/ppage/新化老街"
    },
    {
        "id": 25,
        "image": require("../images/hotsearchPlay/play_25.webp"),
        "imageSmall": require("../images/hotsearchPlay/play_25_330w.webp"),
        "name": "樹谷生活科學館",
        "link": "https://www.pixnet.net/ppage/樹谷生活科學館"
    }
];
